import React,{useState} from 'react';
import * as ReactDOM from 'react-dom';
import { getmessage,reducearray,arrprtojson } from './Dynamictable';

export const getaminities = (railway: any,busstop:any,hospital:any,school:any)=>{
return(
<div className="per100">
			 <div className="search-title-bar">
                       	<div className="search-title">
			  Aminities
			</div>
			<a href="#" onClick={e => aminitclose()} title="Aminities">
			<div className="search-title-toggle" id="togglesearch">
			  X
			</div>
			</a>
	   	     </div>
		    <div className="Sikaamsgbody" style={{backgroundColor:'#bfd3d3'}}>
		     <div style={{width:'100%',display:'table'}} >	
			<div className="Sikaamsginerbody" style={{backgroundColor:'#bfd3d3',width:'90%'}}>
			<span className="aminity-items">Railway Satation: {railway}km</span> <span className="aminity-items">Bus stop: {busstop}km </span>
		        </div>
                      </div>
		     <div style={{width:'100%',display:'table'}}>	
			<div className="Sikaamsginerbody" style={{backgroundColor:'#bfd3d3',width:'90%'}}>
			<span className="aminity-items">Hospital: {hospital}km</span> <span className="aminity-items">School:{school}km </span>
		        </div>
		    </div>
		  
		    </div>
		
		</div>
);
}
export const aminitclose=()=>{
 const Pdivr = document.getElementById('customemsgdiv') as HTMLElement;
		Pdivr.style.display = 'none';
	
}
